import { render, staticRenderFns } from "./MessageSetting.vue?vue&type=template&id=b0730bf0&scoped=true&"
import script from "./MessageSetting.vue?vue&type=script&lang=js&"
export * from "./MessageSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0730bf0",
  null
  
)

export default component.exports